<button *ngIf="tenderData?.allowEditQuotation" nz-button nzSize="large"
	class="border-radius-5 btn-danger"
	(click)="showAllowEditQuotation(!tenderData?.allowEditQuotation)">
	<i nz-icon nzType="minus" nzTheme="outline"></i>
	{{ "global.buyer.tender.decline_edit_quotation"| translate }}
</button>
<button *ngIf="!tenderData?.allowEditQuotation" nz-button nzSize="large"
	(click)="showAllowEditQuotation(!tenderData?.allowEditQuotation)"
	class="button-grey border-radius-5">
	<i nz-icon nzType="plus" nzTheme="outline"></i>
	{{ "global.buyer.tender.allow_edit_quotation" | translate }}
</button>
